import { Injectable } from '@angular/core';

import { LoggerService } from '../logger/logger.service';

declare global {
	interface Window {
		// Beamer embed (index.html) is configured `lazy: true`, so it only shows
		// announcements after init() runs — gated to authenticated users via this service.
		Beamer?: { init: () => void };
	}
}

@Injectable({
	providedIn: 'root'
})
export class BeamerService {
	private readonly loggerName: string = 'BeamerService';

	private initialized = false;

	constructor(private logger: LoggerService) {}

	// The embed is `lazy`, so Beamer never surfaces until init() runs. Call this only
	// for an authenticated, company-verified user so announcements can't pop over the
	// /login page. Guarded to init at most once — once active, Beamer stays active for
	// the session (there is no embed teardown to call), which is intentional.
	init(): void {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.logger.trace(this.loggerName, 'init()');
		window.Beamer?.init();
	}
}
